import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Modal } from 'bootstrap';

import { MapService } from '../map.service';

@Component({
	selector: 'app-map-vehicles',
	templateUrl: './map-vehicles.component.html',
	styleUrls: ['./map-vehicles.component.css'],
})
export class MapVehiclesComponent {
	vehicleToAdd: string = null;

	@Input() vehiclesAll: Array<any> = [];
	@Input() vehicles: Array<any> = [];
	@Output() vehiclesChange = new EventEmitter();
	@Output() selected = new EventEmitter();

	constructor(public service: MapService) {}

	toggle(): void {
		const modal = Modal.getInstance(document.getElementById('addModal'));
		if (!modal) {
			new Modal(document.getElementById('addModal')).show();
			return;
		}
		modal.toggle();
	}

	selectVehicle(vehicle): void {
		this.service.selectVehicle(vehicle);
		this.toggle();
	}

	vehicleAdd(vehicleToAdd): void {
		if (!vehicleToAdd) {
			return;
		}
		const vehicle = this.vehiclesAll.find((obj) => obj.id == vehicleToAdd);
		vehicle.occupied = 0;
		vehicle.crew = 0;
		this.vehicles.push(vehicle);
		this.vehicleToAdd = null;
		this.selectVehicle(vehicle);
	}

	vehicleRemove(vehicle) {
		this.vehicles.splice(this.vehicles.indexOf(vehicle), 1);
	}
}
